import React from "react";
import { useTranslation } from "react-i18next";
import { Program } from "types";
import { ThreeElements, Custom, PriceLabel, Price } from "./TotalAmountStyle";
import ConvertNumberToWords from "./utils/NumberConverter";

type FreeTrialPriceProps = {
  chosenProgram: Program;
  programType: string;
  classNumber: number;
  language: string;
};
const FreeTrialPrice = ({
  chosenProgram,
  programType,
  classNumber,
  language,
}: FreeTrialPriceProps) => {
  const { t } = useTranslation("new_sign_up");
  return (
    <>
      <Custom style={{ color: "black" }} />
      <ThreeElements>
        <PriceLabel>{t("Total")}</PriceLabel>
        <Price>0 {chosenProgram.currency.toUpperCase()} </Price>
      </ThreeElements>
      {!chosenProgram.type.includes("package") && (
        <div
          style={{
            whiteSpace: "normal",
            textAlign: "left",
            paddingRight: "10px",
            fontSize: "16px",
            color: "rgba(0,0,0,0.9)",
          }}
        >
          <span>
            {t("Continues with")}{" "}
            <ConvertNumberToWords value={classNumber} display="lowercase" />{" "}
            {programType === "group"
              ? t("Group Class").toLowerCase()
              : t("One-On-One Class").toLowerCase()}
            {classNumber > 1 && language === "en" && "es"} {t("at")}{" "}
          </span>
          <span>
            {chosenProgram.price} {chosenProgram.currency.toUpperCase()}{" "}
            {t("every 4 weeks.")}
            {/* TODO: Handle Case for 0 Class */}
          </span>
        </div>
      )}
      {chosenProgram.type.includes("package") && (
        <div
          style={{
            whiteSpace: "normal",
            textAlign: "left",
            paddingRight: "10px",
            fontSize: "16px",
            color: "rgba(0,0,0,0.9)",
          }}
        >
          <span>
            {t("After trial receive")}{" "}
            <ConvertNumberToWords value={classNumber} display="lowercase" />{" "}
            {programType === "group"
              ? t("Group Class").toLowerCase()
              : t("One-On-One Class").toLowerCase()}
            {classNumber > 1 && language === "en" && "es"}{" "}
            {t("charged as a non-recurring payment of")}{" "}
          </span>
          <span>
            {chosenProgram.price} {chosenProgram.currency.toUpperCase()}.
            {/* TODO: Handle Case for 0 Class */}
          </span>
        </div>
      )}
    </>
  );
};

export default FreeTrialPrice;
